import { get, includes } from 'lodash/fp';
import qs from 'qs';
import {
  ItemType,
  PackageType
} from '../../constants/inventory/InventoryTypes';
import {
  inventoryItemsPath,
  inventoryPackagesPath,
  inventoryEditItemPath,
  inventoryViewItemPath,
  inventoryViewPackagePath,
  inventoryCreateItemPath,
  inventoryEditPackagePath,
  inventoryCreatePackagePath,
  inventoryAdjustItemPath,
  inventoryAdjustPackagePath
} from '../../routes/Paths';

const pathsByType = {
  [ItemType]: {
    list: inventoryItemsPath,
    new: inventoryCreateItemPath,
    view: inventoryViewItemPath,
    edit: inventoryEditItemPath,
    adjust: inventoryAdjustItemPath
  },
  [PackageType]: {
    list: inventoryPackagesPath,
    new: inventoryCreatePackagePath,
    view: inventoryViewPackagePath,
    edit: inventoryEditPackagePath,
    adjust: inventoryAdjustPackagePath
  }
};

const isPathWithId = includes(['edit', 'view', 'adjust']);

export default (pathFor, { id = '', itemType }, query) => ({
  pathname: get(`${itemType}.${pathFor}`, pathsByType).replace(':id', id),
  params: isPathWithId(pathFor) ? { id } : {},
  ...(query ? { search: `?${qs.stringify(query)}` } : {})
});
